module.exports = __webpack_public_path__ + "media/images/pic/polygon-camps-big-6ed1fbb079b88339ab13f415424ab3d6.svg";